"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "pluralize", {
    enumerable: true,
    get: function() {
        return pluralize;
    }
});
const pluralize = (value, fallback = "s")=>value === 1 ? "" : fallback;
